export default {
  cookieToken: 'token',
  client_id: 'KerunWeb'
}